import { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import * as S from './style';

type ButtonTypes =
  | AnchorHTMLAttributes<HTMLAnchorElement>
  | ButtonHTMLAttributes<HTMLButtonElement>;

export type FormButtonType = {
  icon?: JSX.Element;
  as?: 'a' | 'button';
  fullWidth?: boolean;
  format?: 'primary' | 'secondary';
  isProcessing?: boolean;
  isSuccess?: boolean;
} & ButtonTypes;

const FormButton = ({
  children,
  icon,
  fullWidth = false,
  as = 'button',
  format = 'primary',
  ...props
}: FormButtonType) => {
  return (
    <S.Wrapper as={as} format={format} fullWidth={fullWidth} {...props}>
      <span>{children}</span>
      {!!icon && icon}
    </S.Wrapper>
  );
};

export default FormButton;
